import { render, staticRenderFns } from "./ChannelInvitelist.vue?vue&type=template&id=7f050c33"
import script from "./ChannelInvitelist.vue?vue&type=script&lang=js"
export * from "./ChannelInvitelist.vue?vue&type=script&lang=js"
import style0 from "./ChannelInvitelist.vue?vue&type=style&index=0&id=7f050c33&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports